import React from "react";
import { GeneralSessionGrid } from "components/widgets/general-sessions-grid";

export function AADPage(){
  return <GeneralSessionGrid />
}
